//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Search from "@/components/Search";
export default {
    name: "orderConfirm",
    components: { Search },
    data() {
        return {
            form: {
                user_coupon_id: "",
                address_id: "",
                integral: "",
                cart_id: "",
                delivery_time: "",
                buyer_remark: "",
                youhuima: "",
                songallcount: 0,
                songarr: []
            },
            provOptions: [
                '香港島',
                '九龍',
                '新界'
            ],
            activeTab: 'all',
            cityOptions: [],
            districtOptions: [{
                id: 1292,
                additional_deliver_fee: "0.00",
                address: "北角丹拿花園地下停車場",
                area: 1,
                code: "H852P037P",
                d_limit: "45x31x35cm",
                latlng: "22.290297,114.202415",
                opening_hours: "00:00-23:59 周六:00:00-23:59 周日:00:00-23:59 節假日:00:0",
                sf: 1,
                tags: "",
                type: 2,
                w_limit: "20,un",
                zeek: 0,
                zone: "北角",
                zto: 0
            }],
           
            sfLockerInfo: {
                id: '',
                address: '',
                code: '',
                zone: '',
                d_limit: '',
                w_limit: '',
                opening_hours: '',
                latlng: '',
                type: '',
                sf: '',
                zeek: '',
                zto: '',
                area: '',
                tags: '',
                additional_deliver_fee: ''
            },
            dialogVisible: false,
            sfAddressDialogVisible:false,
            addressForm: {
                contact: '',
                contact_number: '',
                address: '',
                house_number: '',
                is_default: true,
                province: '',
                city: '',
                district: '',
                longitude: '',
                latitude: '',
                address_id: ''
            },
            couponList: [],
            settlement: null
        };
    },

    created() {
        this.form.cart_id = this.$route.params.cart_id || ''
        this.getsettlement()
    },

    methods: {
        changeCoupon() {
            this.getsettlement()
        },
        // 获取结算信息
        async getsettlement() {
            const res = await this.$http.get("/settlement", this.form);
            if (res.code !== 0) {
                return this.$message.error(res.message);
            }
            this.settlement = res.data;
            this.form.songallcount = this.settlement.songallcount;
			this.couponList = this.settlement.coupon.list.map(item => {
                item.label = '满' + item.minimum + '减' + item.discount
                item.value= item.user_coupon_id
                return item
            })
            // this.form.songarrlite = JSON.stringify(this.settlement.songarrlite);
            this.form.songarrlite = this.settlement.songarrlite 
            this.form.charges = this.settlement.charges 
        },


        // 获取区域可用zone
        async fetchZoneUseAria(province) {
            let area_id = 0
            if (province === '全部') {
                this.addressForm.province = '';
                this.addressForm.city = '';
                this.addressForm.district = '';
                return;
            }
            if (province === '香港島') {
                area_id = 1;
            } else if (province === '九龍') {
                area_id = 2;
            } else if (province === '新界') {
                area_id = 3;
            } else {
                this.addressForm.province = province;
                this.addressForm.city = '';
                this.addressForm.district = '';
                return;
            }

            try {
            const res = await this.$http.get('order/getZoneUseAria', { area_id });
            if (res.code === 0) {
                // 返回 zones 数组
                console.log('zones:', res.data)
               
                this.cityOptions =  res.data.zones;
                 this.addressForm.city =  this.cityOptions[0] || '';
            } else {
                this.$message.error(res.message || '獲取區域失敗');
                return [];
            }
            } catch (e) {
            this.$message.error('接口請求失敗');
            return [];
            }
        },
      async  handleCitychange() {
            console.log('Selected city:', this.addressForm.city);
            // 根据选中的城市更新区县选项
           // this.fetchDistrictsByCity(value);

            if (!this.addressForm.city) {
                this.districtOptions = [];
                this.addressForm.district = '';
                return;
            }
            try {
                // 假设 city 是 zone，address 为空字符串，area 由省份决定
                let area = 0;
                if (this.addressForm.province === '香港島') area = 1;
                else if (this.addressForm.province === '九龍') area = 2;
                else if (this.addressForm.province === '新界') area = 3;

                const res = await this.$http.get('order/shunfengStores', {
                    zone: this.addressForm.city,
                    address: '',
                    area
                });
                if (res.code === 0 && res.data && res.data.stores) {
                    this.districtOptions = res.data.stores;
                    this.addressForm.district = this.districtOptions.length > 0 ? this.districtOptions[0].id : '';
                } else {
                    this.districtOptions = [];
                    this.addressForm.district = '';
                    this.$message.error(res.message || '獲取快遞櫃失敗');
                }
            } catch (e) {
                this.districtOptions = [];
                this.addressForm.district = '';
                this.$message.error('接口請求失敗');
            }

        },
        //提交订单
        async formSubmit() {
			
			var ss = window.localStorage.getItem('webinfo');
			var ssarray = JSON.parse(ss)
			var uniacid = ssarray.uniacid
			
            let form = this.form
            for (let i in this.settlement) form = { ...form,
                ...this.settlement[i].form
            }
            let cartIdList = []
            this.settlement.goods.list.forEach(item => {
                cartIdList.push(item.cart_id)
            })
            form.cart_id = cartIdList.join(',')
			form.uniacid = uniacid 
            console.log('form;',form)
           // return 
            const res = await this.$http.post('/settlement/submit', form)
            console.log(res)
            if (res.code != 0) {
               return this.$message.error(res.message);
            }
            this.$router.push({name: 'User'})
        },

         // 提交 
        async orderFormSubmit() {
            let form = this.addressForm
            form.is_default = Number(form.is_default)
            let region = form.region || []
            form.province = region.shift() || ''
            form.city = region.shift() || ''
            form.district = region.shift() || ''
            const api = '/user.address/' + ('add')
            const res = await this.$http.post(api, form)
            if (res.code == 0) {
                this.dialogVisible = false
                this.getsettlement()
            }else{
                return this.$message.error(res.message)
            }
        },
    }
};
